<template>
  <div class="quote-page">
    <div class="flex-container">
      <div class="select-component">
        <SelectComponent
          :options="partnersCascader"
          title="Selezionare un partner"
          :add-buttom="false"
          :is-disabled="false"
          @selected="handleChangePartner"
        />
      </div>

      <div class="select-component">
        <SelectComponent
          :options="headquartersCascader"
          title="Selezionare una sede"
          :add-buttom="false"
          :highlight="highlightHeadquarter"
          :is-disabled="false"
          @selected="handleChangeHeadquarter"
        />
      </div>

      <div class="select-component">
        <!-- TIPO SERVIZIO: solo quelli abilitati per il partner
             (is_restaurant / booking_type / journey_type): il backend
             risponde 403 su un flusso non abilitato -->
        <SelectComponent
          :options="serviceOptions"
          :title="
            selectedPartner
              ? 'Seleziona un tipo di servizio'
              : 'Prima seleziona un partner'
          "
          :add-buttom="false"
          :is-disabled="!selectedPartner"
          :value="serviceValue"
          @selected="handleChangeService"
        />
      </div>
    </div>

    <el-form :model="booking">
      <!-- PUNTO DI PRELIEVO -->
      <div class="container-point">
        <PointComponent
          :value="booking.point_origin.address"
          title="Punto di prelievo"
          label="Indirizzo"
          placeholder="Indirizzo"
          :span="8"
          @input="(v) => (booking.point_origin.address = v)"
          @focus="handleInputFocusFirst"
          @blur="handleInputBlurFirst"
        />
        <PointComponent
          :value="booking.point_origin.street_number"
          label="N. civico"
          placeholder="N. civico"
          @input="(v) => (booking.point_origin.street_number = v)"
          @focus="handleInputFocusFirst"
          @blur="handleInputBlurFirst"
        />
        <PointComponent
          :value="booking.point_origin.cap"
          label="CAP"
          placeholder="CAP"
          @input="(v) => (booking.point_origin.cap = v)"
          @focus="handleInputFocusFirst"
          @blur="handleInputBlurFirst"
        />
        <PointComponent
          :value="booking.point_origin.city"
          :span="4"
          label="Città"
          placeholder="Città"
          @input="(v) => (booking.point_origin.city = v)"
          @focus="handleInputFocusFirst"
          @blur="handleInputBlurFirst"
        />
        <PointComponent
          :value="booking.point_origin.province"
          label="Provincia"
          placeholder="Provincia"
          @input="(v) => (booking.point_origin.province = v)"
          @focus="handleInputFocusFirst"
          @blur="handleInputBlurFirst"
        />
      </div>
      <DescriptionComponent
        :label="booking.point_origin.label"
        :loading="loadingPoint"
      />

      <!-- PUNTO DI CONSEGNA -->
      <div class="container-point">
        <PointComponent
          :value="booking.point_destination.address"
          title="Punto di consegna"
          label="Indirizzo"
          placeholder="Indirizzo"
          :span="8"
          @input="(v) => (booking.point_destination.address = v)"
          @focus="handleInputFocusSecond"
          @blur="handleInputBlurSecond"
        />
        <PointComponent
          :value="booking.point_destination.street_number"
          label="N. civico"
          placeholder="N. civico"
          @input="(v) => (booking.point_destination.street_number = v)"
          @focus="handleInputFocusSecond"
          @blur="handleInputBlurSecond"
        />
        <PointComponent
          :value="booking.point_destination.cap"
          label="CAP"
          placeholder="CAP"
          @input="(v) => (booking.point_destination.cap = v)"
          @focus="handleInputFocusSecond"
          @blur="handleInputBlurSecond"
        />
        <PointComponent
          :value="booking.point_destination.city"
          :span="4"
          label="Città"
          placeholder="Città"
          @input="(v) => (booking.point_destination.city = v)"
          @focus="handleInputFocusSecond"
          @blur="handleInputBlurSecond"
        />
        <PointComponent
          :value="booking.point_destination.province"
          label="Provincia"
          placeholder="Provincia"
          @input="(v) => (booking.point_destination.province = v)"
          @focus="handleInputFocusSecond"
          @blur="handleInputBlurSecond"
        />
      </div>

      <DescriptionComponent
        :label="booking.point_destination.label"
        :loading="loadingPoint"
      />
    </el-form>

    <!-- CALCOLA -->
    <el-button
      type="primary"
      style="margin-top: 20px"
      @click="calcolaKm"
    >
      Calcola preventivo
    </el-button>

    <!-- RISULTATI -->
    <div
      class="info-container"
      style="margin-top: 20px"
    >
      <div class="info-item">
        <PriceComponent
          :label="selectedService === 'journey' ? 'Distanza' : 'Fascia km'"
          :value="`${responseKm} km`"
          tag-type="info"
        />
      </div>
      <div
        v-if="selectedService === 'journey'"
        class="info-item"
      >
        <PriceComponent
          label="Durata stimata"
          :value="`${responseMin} min`"
          tag-type="info"
        />
      </div>
      <div class="info-item">
        <PriceComponent
          :label="selectedService === 'journey' ? 'Prezzo (fasce km)' : 'Tariffa'"
          :value="responseCost === null ? 'n.d.' : `${responseCost} euro`"
          :tag-type="responseCost === null ? 'warning' : 'success'"
        />
      </div>
    </div>
    <p
      v-if="quoteNote"
      style="margin-top: 8px; color: #909399"
    >
      {{ quoteNote }}
    </p>
  </div>
</template>

<script>
import { ref, toRaw, computed } from 'vue';
import SelectComponent from '../../components/SelectComponent.vue';
import PointComponent from '../../components/PointComponent.vue';
import DescriptionComponent from '../../components/DescriptionComponent.vue';
import PriceComponent from '../../components/PriceComponent.vue';
import bookingAPI from '../../services/bookingAPI.js';
import partnerAPI from '../../services/partnerAPI.js';
import prenotazioneAPI from '../../services/prenotazioneAPI';
import journeyAPI from '../../services/journeyAPI.js';
import { isEmpty } from 'lodash';

export default {
  name: 'PickupComponent',
  components: {
    PointComponent,
    SelectComponent,
    DescriptionComponent,
    PriceComponent,
  },

  setup() {
    const booking = ref({
      point_origin: {
        address: '',
        street_number: '',
        cap: '',
        city: '',
        province: '',
        label: '',
        latitude: 0,
        longitude: 0,
      },
      point_destination: {
        address: '',
        street_number: '',
        cap: '',
        city: '',
        province: '',
        label: '',
        latitude: 0,
        longitude: 0,
      },
    });

    //partner
    let partnersCascader = ref([]);
    const partnersId = ref([]);

    const loadPartners = async () => {
      try {
        const response = await partnerAPI.getPartners();

        response.data.forEach((partner) => {
          let tableRow = {
            value: partner.id,
            label: `${partner.company_name}`,
          };
          partnersCascader.value.push(tableRow);
          partnersId.value.push(partner);
        });
      } catch (e) {
        console.error('error', e);
      }
    };

    loadPartners();

    // PARTNER SELEZIONATO
    const selectedPartner = ref(null);
    const handleChangePartner = async (val) => {
      const partner = partnersId.value.find(
        (partner) => partner.id == (Array.isArray(val) ? val[0] : val)
      );

      // Cambio partner: azzero sede, preventivo e servizio precedenti
      headquarterSelect.value = '';
      headquartersCascader.value = [];
      headquartersId.value = [];
      resetResults();

      if (partner) {
        const rawPartner = toRaw(partner);
        selectedPartner.value = rawPartner;
        // Servizio di default: il primo abilitato per il partner
        selectedService.value = serviceOptions.value[0]?.value ?? '';
        await loadHeadquarters(rawPartner);
      } else {
        selectedPartner.value = null;
        selectedService.value = '';
      }
    };

    //sede
    let headquarterSelect = ref('');
    let headquartersCascader = ref([]);
    const headquartersId = ref([]);

    const loadHeadquarters = async (partner) => {
      try {
        const response = await partnerAPI.getPartnerById(partner.id);

        response.data[0].headquarters.forEach((headquarter) => {
          let tableRow = {
            value: headquarter.id,
            label: `${headquarter.address} ${headquarter.street_number} ${headquarter.city}`,
          };
          headquartersCascader.value.push(tableRow);
          headquartersId.value.push(headquarter);
        });
      } catch {
        console.error('error');
      }
    };

    const responseKm = ref(0);
    const responseMin = ref(0);
    const responseCost = ref(0); // null = nessun listino applicabile
    const quoteNote = ref('');
    const resetResults = () => {
      responseKm.value = 0;
      responseMin.value = 0;
      responseCost.value = 0;
      quoteNote.value = '';
    };

    // SEDE SELEZIONATA
    const handleChangeHeadquarter = async (val) => {
      const sede = headquartersId.value.filter(
        (headquarter) => headquarter.id == val
      )[0];

      if (sede) {
        headquarterSelect.value = sede;
        booking.value.point_origin = { ...sede };
        let resp = await loadPoints(booking.value.point_origin);

        booking.value.point_origin.label = resp[0].label;
        booking.value.point_origin.latitude = resp[0].point.latitude;
        booking.value.point_origin.longitude = resp[0].point.longitude;
      }
    };
    // Servizi preventivabili per il partner selezionato, dalle sue capability:
    //  - is_restaurant -> 'mobility'  (POST /pickup/range-restaurant)
    //  - booking_type  -> 'pickup'    (POST /pickup/range)
    //  - journey_type  -> 'journey'   (POST /journey/leg-distance + /tariff-band/quote)
    const serviceOptions = computed(() => {
      const p = selectedPartner.value;
      if (!p) return [];
      const opts = [];
      if (p.is_restaurant) {
        opts.push({ value: 'mobility', label: 'Mobility (ristorante)' });
      } else if (p.booking_type) {
        opts.push({ value: 'pickup', label: 'Pickup' });
      }
      if (p.journey_type && !p.is_restaurant) {
        opts.push({ value: 'journey', label: 'Spostamento interno (journey)' });
      }
      return opts;
    });
    const selectedService = ref('');
    const serviceValue = computed(() =>
      selectedService.value ? [selectedService.value] : []
    );
    const handleChangeService = (val) => {
      const v = Array.isArray(val) ? val[0] : val;
      if (v !== selectedService.value) {
        selectedService.value = v || '';
        resetResults();
      }
    };

    const pointToString = (point) => {
      const address = point.address ? point.address : '';
      const street_number = point.street_number ? point.street_number : '';
      const city = point.city ? point.city : '';
      const province = point.province ? point.province : '';
      const cap = point.cap ? point.cap : '';

      return (
        address + ' ' + street_number + ' ' + cap + ', ' + city + ' ' + province
      );
    };

    let loadingPoint = ref(true);

    const loadPoints = async (point) => {
      try {
        const response = await prenotazioneAPI.getPoints({
          text: pointToString(point),
        });

        loadingPoint.value = false;
        return response.data;
      } catch (error) {
        console.error(error);
        return [];
      }
    };

    const isInputFocused = ref(false);

    const handleInputFocusFirst = () => {
      isInputFocused.value = true;
    };
    const handleInputBlurFirst = async () => {
      isInputFocused.value = false;

      if (
        booking.value.point_origin.address != '' &&
        booking.value.point_origin.street_number != '' &&
        booking.value.point_origin.city != '' &&
        booking.value.point_origin.cap != '' &&
        booking.value.point_origin.province != ''
      ) {
        let resposnePointGone = await loadPoints(booking.value.point_origin);

        booking.value.point_origin.label = resposnePointGone[0].label;
        booking.value.point_origin.latitude =
          resposnePointGone[0].point.latitude;
        booking.value.point_origin.longitude =
          resposnePointGone[0].point.longitude;
      }
    };

    const handleInputFocusSecond = () => {
      isInputFocused.value = true;
    };
    const handleInputBlurSecond = async () => {
      isInputFocused.value = false;

      if (
        booking.value.point_destination.address != '' &&
        booking.value.point_destination.street_number != '' &&
        booking.value.point_destination.city != '' &&
        booking.value.point_destination.cap != '' &&
        booking.value.point_destination.province != ''
      ) {
        let resposnePointGone = await loadPoints(
          booking.value.point_destination
        );

        booking.value.point_destination.label = resposnePointGone[0].label;
        booking.value.point_destination.latitude =
          resposnePointGone[0].point.latitude;
        booking.value.point_destination.longitude =
          resposnePointGone[0].point.longitude;

      }
    };

    let request_mobility = {
      headquarter_id: '',
      origins_point: {},
      destination_point: {},
      date: new Date(),
    };

    let request = {
      headquarter_id: '',
      origins_point: {},
      destination_point: {},
      loaner: false,
    };

    const calcolaKm = async () => {
      try {
        if (
          !isEmpty(toRaw(booking.value.point_origin)) &&
          !isEmpty(toRaw(booking.value.point_destination)) &&
          selectedService.value == 'pickup'
        ) {
          request.headquarter_id = headquarterSelect.value.id;
          request.origins_point = toRaw(booking.value.point_origin);
          request.destination_point = toRaw(booking.value.point_destination);
          const response = await bookingAPI.getRangePickup(request);

          responseKm.value = response.data.kmRange;
          responseCost.value = response.data.cost;
        } else if (
          !isEmpty(toRaw(booking.value.point_origin)) &&
          !isEmpty(toRaw(booking.value.point_destination)) &&
          selectedService.value == 'mobility'
        ) {
          request_mobility.headquarter_id = headquarterSelect.value.id;
          request_mobility.origins_point = toRaw(booking.value.point_origin);
          request_mobility.destination_point = toRaw(
            booking.value.point_destination
          );
          const response = await bookingAPI.getRangeRestaurant(
            request_mobility
          );

          responseKm.value = response.data.kmRange;
          responseCost.value = response.data.cost;
        } else if (
          !isEmpty(toRaw(booking.value.point_origin)) &&
          !isEmpty(toRaw(booking.value.point_destination)) &&
          selectedService.value == 'journey'
        ) {
          // Journey: distanza/tempo reali della tratta + prezzo dalle fasce km
          // del partner (o listino globale). Nessuna sede richiesta.
          const leg = await journeyAPI.legDistance(
            legPoint(booking.value.point_origin),
            legPoint(booking.value.point_destination)
          );
          responseKm.value = Math.round(leg.data.km * 100) / 100;
          responseMin.value = Math.round(leg.data.min);

          const quote = await journeyAPI.quote(
            selectedPartner.value.id,
            leg.data.km,
            new Date().toISOString().slice(0, 10)
          );
          responseCost.value = quote.data.price;
          quoteNote.value =
            quote.data.price === null
              ? 'Nessuna fascia tariffaria (partner o globale) copre questa distanza: prezzo non disponibile.'
              : `€/km applicato: ${quote.data.price_per_km} (listino ${
                  quote.data.scope === 'partner' ? 'del partner' : 'globale'
                })`;
        }
      } catch (error) {
        console.error(error);
      }
    };

    // Punto nel formato richiesto da /journey/leg-distance (PointLegDto)
    const legPoint = (p) => ({
      address: p.address || '',
      street_number: String(p.street_number ?? ''),
      cap: String(p.cap ?? ''),
      city: p.city || '',
      province: p.province || '',
      latitude: p.latitude || undefined,
      longitude: p.longitude || undefined,
    });

    return {
      headquartersCascader,
      headquartersId,
      handleChangeHeadquarter,
      booking,
      responseKm,
      responseCost,
      loadingPoint,
      handleInputFocusFirst,
      handleInputBlurFirst,
      handleInputFocusSecond,
      handleInputBlurSecond,
      calcolaKm,
      selectedPartner,
      selectedService,
      serviceOptions,
      serviceValue,
      handleChangeService,
      responseMin,
      quoteNote,
      handleChangePartner,
      partnersCascader,
      partnersId,
    };
  },
};
</script>

<style scoped>
.container-point {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 20px;
}
.info-container {
  display: flex;
  gap: 20px;
}
.container-point {
    display: flex;
    padding-top: 2%;
    flex-wrap: wrap;
  }
  
  .container-point > * {
    margin-right: 10px;
    margin-bottom: 10px;
  }
  
  .container-point > *:last-child {
    margin-right: 0;
  }
  
.flex-container {
    display: flex;
    justify-content: space-between;
  }
  
  .select-component:last-child {
    margin-right: 0;
  }
  
  .select-component {
    flex: 2;
    margin-right: 20px;
  }
  .info-container {
    display: flex;
    justify-content: center;
    gap: 22px;
    margin-top: 20px;
  }
</style>
